export const SKILLS_DATA = {
  econometrics: [
    "STATA",
    "EViews",
    "Gretl",
    "R (tidyverse, dplyr)",
    "Python (pandas, NumPy, statsmodels)",
    "SPSS",
    "SAS",
    "Excel (Advanced, Power Query, Power Pivot)",
    "Time Series Analysis",
    "Panel Data Analysis",
    "Microeconometrics",
    "Macroeconometrics",
    "Bayesian Econometrics",
    "Forecasting Models",
    "Maximum Likelihood Estimation (MLE)",
    "Generalized Method of Moments (GMM)",
    "Survey Data Analysis",
    "Experimental Data Analysis",
    "Causal Inference",
    "Econometric Model Diagnostics"
  ],
  ml: [
    "OLS / GLS / WLS",
    "IV / 2SLS / 3SLS",
    "Difference-in-Differences (DID)",
    "Regression Discontinuity Design (RDD)",
    "Synthetic Control",
    "VAR / VECM",
    "ARIMA / SARIMA / State Space Models / Kalman Filter",
    "Random Forest",
    "XGBoost / LightGBM / CatBoost",
    "LASSO / Ridge / ElasticNet",
    "Gradient Boosting",
    "SVM, KNN, Naive Bayes, Decision Trees",
    "PCA, Feature Engineering",
    "Clustering (k-means, hierarchical)",
    "Neural Networks (basic)",
    "Ensemble Methods",
    "Model Evaluation & Cross-Validation",
    "Outlier Detection",
    "A/B Testing (statistical testing)",
    "Probability & Distributions (applied)"
  ],
  business: [
    "Power BI",
    "Tableau",
    "Google Data Studio / Looker Studio",
    "Dashboarding & Reporting",
    "KPI Design & Monitoring",
    "Business Forecasting",
    "Market Sizing",
    "Financial Modelling (DCF, valuation, capital budgeting basics)",
    "Risk Analytics (Credit, Market, Operational)",
    "Credit Risk Modelling (PD models, stress testing basics)",
    "Portfolio Concepts / Portfolio Optimization (basics)",
    "Financial Statement Analysis",
    "Unit Economics & Pricing Analytics",
    "Product & Marketing Analytics (cohort analysis, consumer behaviour)",
    "SQL Analytics (analytics queries, aggregation)",
    "ETL Pipelines (basic)",
    "Business Case Development",
    "A/B Testing (analytics implementation)"
  ],
  programming: [
    "Python (general: pandas, NumPy, SciPy, scikit-learn)",
    "R (general, RStudio)",
    "SQL (PostgreSQL, MySQL)",
    "NoSQL basics (MongoDB)",
    "Git / GitHub",
    "Jupyter Notebook / JupyterLab",
    "VS Code / RStudio IDE",
    "Docker (basic)",
    "Bash / Shell Scripting / Linux command line",
    "APIs (REST) / JSON / YAML",
    "Airflow (basic workflows)",
    "Excel VBA",
    "HTML / CSS (basic)",
    "Streamlit / Dash (for quick ML apps)",
    "LaTeX",
    "Pandoc (conversion knowledge)"
  ],
  research: [
    "Data Cleaning & Wrangling",
    "Data Visualization (ggplot2, matplotlib, tableau visuals)",
    "Academic Writing & Report Writing (technical & non-technical)",
    "Literature Review",
    "Presentation & Storytelling",
    "Survey Design & Questionnaire Development",
    "Interview & Field Survey Methods",
    "Policy Evaluation & Impact Assessment (RCTs, quasi-experimental)",
    "Monitoring & Evaluation (M&E)",
    "Cost–Benefit Analysis",
    "Economic Modelling (concepts & communicating results)",
    "Stakeholder Communication & Project Management",
    "Research Ethics & Data Governance",
    "Policy Briefs & Policy Drafting",
    "Social Sector / Health / Labour / Poverty Metrics (domain-specific methods)"
  ]
};

export const SKILLS_CATEGORIES = {
  econometrics: "Econometrics & Data Analysis",
  ml: "Statistical & ML Techniques",
  business: "Business & Data Analytics",
  programming: "Programming & Tools",
  research: "Research & Consulting Skills"
};
